export const getInitTransportLocalitiesParams = {
  sizePerPage: 10,
  page: 1,
  sort: "-maker_date",
  columnFilter: {},
  keywords: "",
  columnsVisible: {},
  fields: "",
  expand: "",
  run: false,
};

export const MODE_DETAIL = {
  CREATE: "create",
  UPDATE: "update",
};
